var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditarPreta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.998,
    height: 12,
    viewBox: "0 0 11.998 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 11.998,
    height: 12,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.998,
    height: 12,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M0 12V9.4998169l7.37130737-7.3734131 2.4994812 2.50018311L2.4994812 12H0zm1.3328247-1.33380127h.61303712L7.98434448 4.6260376l-.6130371-.61322022L1.3328247 10.0524292v.61376953z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M11.80345524 1.7532l-1.55955806-1.56c-.26022934-.25799671-.67970432-.25799671-.93993365 0L8.08450908 1.4136l2.50129121 2.4996 1.21765495-1.2198c.12479549-.12459724.19492453-.29372763.19492453-.4701s-.07012904-.34550276-.19492453-.4701z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarPreta);
export default __webpack_public_path__ + "static/media/editar_preta.e15266c43eb20c857c98a9c134bafb29.svg";
export { ForwardRef as ReactComponent };